<div>
    <div>
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="showLocation">Show Location</label>
            <div class="filter-label">
                <ccl-toggle-button
                [title]="calendarConfig.showLocation ? 'Enable' : 'Disable'"
                [isChecked]="calendarConfig.showLocation"
                (isCheckedChange)="toggleHTMLEnable($event,'showLocation')"
                >{{ calendarConfig.showLocation ? "Enabled" : "Disabled" }}</ccl-toggle-button
            >
            </div>
        </div>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>

    </div>

    <div>
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="showSpeakers">Show Speakers</label>
            <div class="switch-filter-label">
            <ccl-toggle-button
                [title]="calendarConfig.showSpeakers ? 'Enable' : 'Disable'"
                [isChecked]="calendarConfig.showSpeakers"
                (isCheckedChange)="toggleHTMLEnable($event,'showSpeakers')"
                >{{ calendarConfig.showSpeakers ? "Enabled" : "Disabled" }}</ccl-toggle-button
            >
        </div>
    </div>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
</div>